module.exports = __webpack_public_path__ + "img/logo-mclick-min.e023bda0.png";